var _rect, _mask, _path, _path2, _path3, _path4, _mask2, _path5, _mask3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _mask4, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _mask5, _path101, _path102, _path103, _rect2, _rect3, _rect4, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 435,
    viewBox: "0 0 163 435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 152,
    y: 412.013,
    width: 152,
    height: 389,
    rx: 13,
    transform: "rotate(-180 152 412.013)",
    fill: "#EFECEC"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3111_39277",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9981 327.175L19.8201 327.685L19.8201 332.399L19.2851 333.144C19.2851 333.144 19.6505 374.006 19.7157 377.009C19.7679 380.026 20.2507 391.009 20.4856 396.533C20.7074 402.044 21.399 415.26 21.399 415.26C21.399 415.26 19.6896 415.626 19.6896 416.174C19.6896 416.723 19.4939 419.987 22.0123 423.67C24.5437 427.366 27.0882 428.959 31.1202 429.664C35.1523 430.37 40.0064 428.894 40.0064 428.894C40.0064 428.894 49.0621 429.847 57.8308 429.86L57.8308 432.355L61.902 434L110.26 434L114.331 432.355L114.331 429.86C123.1 429.86 132.156 428.894 132.156 428.894C132.156 428.894 137.01 430.37 141.042 429.664C145.074 428.959 147.632 427.366 150.15 423.67C152.681 419.974 152.473 416.71 152.473 416.174C152.473 415.639 150.763 415.26 150.763 415.26C150.763 415.26 151.442 402.044 151.677 396.533C151.898 391.022 152.381 380.026 152.446 377.009C152.499 374.006 152.877 333.144 152.877 333.144L152.342 332.399L152.342 327.685L153.177 327.175L153.177 315.853L18.9981 315.853L18.9981 327.175Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9981 327.175L19.8201 327.685L19.8201 332.399L19.2851 333.144C19.2851 333.144 19.6505 374.006 19.7157 377.009C19.7679 380.026 20.2507 391.009 20.4856 396.533C20.7074 402.044 21.399 415.26 21.399 415.26C21.399 415.26 19.6896 415.626 19.6896 416.174C19.6896 416.723 19.4939 419.987 22.0123 423.67C24.5437 427.366 27.0882 428.959 31.1202 429.664C35.1523 430.37 40.0064 428.894 40.0064 428.894C40.0064 428.894 49.0621 429.847 57.8308 429.86L57.8308 432.355L61.902 434L110.26 434L114.331 432.355L114.331 429.86C123.1 429.86 132.156 428.894 132.156 428.894C132.156 428.894 137.01 430.37 141.042 429.664C145.074 428.959 147.632 427.366 150.15 423.67C152.681 419.974 152.473 416.71 152.473 416.174C152.473 415.639 150.763 415.26 150.763 415.26C150.763 415.26 151.442 402.044 151.677 396.533C151.898 391.022 152.381 380.026 152.446 377.009C152.499 374.006 152.877 333.144 152.877 333.144L152.342 332.399L152.342 327.685L153.177 327.175L153.177 315.853L18.9981 315.853L18.9981 327.175Z",
    fill: "url(#paint0_linear_3111_39277)",
    stroke: "#222222",
    strokeWidth: 2,
    mask: "url(#path-2-inside-1_3111_39277)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1889 318.752C55.1889 318.752 22.3977 318.491 21.1059 318.661C19.8141 318.843 19.7749 321.769 19.7749 321.769L19.7749 327.685L19.6836 327.711L19.6836 332.399L19.7749 332.399L20.5187 331.864L20.5187 322.213C20.5187 320.293 21.406 319.588 21.406 319.588L28.6872 319.588L28.6872 323.571L143.28 323.571L143.28 319.588L150.561 319.588C150.561 319.588 151.462 320.293 151.462 322.213L151.462 331.864L152.206 332.399L152.206 321.769C152.206 321.769 152.166 318.83 150.875 318.661C149.583 318.491 116.792 318.752 116.792 318.752C116.792 318.752 116.439 318.621 116.257 317.825C116.152 317.355 116.113 316.506 116.087 315.866L55.8544 315.866C55.8414 316.506 55.7892 317.355 55.6848 317.825C55.5021 318.621 55.1498 318.752 55.1498 318.752L55.1889 318.752Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4586 340.182C21.5499 346.672 21.5891 365.843 21.8109 380.287C22.0327 394.743 23.2854 415.024 23.2854 415.024L24.3032 416.043L27.3305 418.537C27.3305 418.537 28.4004 421.071 28.9224 421.828C29.4574 422.586 39.9615 427.078 39.9615 427.078L39.9615 428.906C40.901 428.998 49.4218 429.847 57.7077 429.86L57.7077 432.354L61.7789 434L110.137 434L114.208 432.354L114.208 429.86C122.977 429.86 132.033 428.893 132.033 428.893L132.033 427.078C132.033 427.078 142.537 422.586 143.072 421.828C143.607 421.071 144.677 418.537 144.677 418.537L147.704 416.043L148.722 415.024C148.722 415.024 149.975 394.743 150.196 380.287C150.418 365.83 150.457 346.672 150.549 340.182C150.64 333.692 150.549 324.576 150.549 324.576L21.4586 324.576C21.4586 324.576 21.3672 333.692 21.4586 340.182ZM23.729 413.588C23.4289 411.616 22.5677 390.473 22.5677 386.033C22.5677 381.593 22.1632 343.695 22.1632 340.051C22.1632 336.408 22.6982 336.982 23.3637 337.701C24.0292 338.406 24.251 338.902 24.251 340.992L24.251 362.069C24.251 367.946 24.6033 388.527 24.7338 394.391C24.8643 400.254 25.6863 407.228 25.6863 407.228L25.3993 411.329C25.3993 411.329 24.0291 415.547 23.716 413.588L23.729 413.588ZM139.81 422.703C134.812 424.597 130.454 425.446 120.759 425.446L50.0351 425.446C40.3399 425.446 35.9817 424.597 30.9841 422.703C25.9864 420.823 27.3044 412.517 27.3044 412.517C27.3044 412.517 31.5713 414.698 36.4384 415.037C39.0481 415.22 51.0659 415.377 51.0659 415.377L119.715 415.377C119.715 415.377 131.733 415.22 134.342 415.038C139.209 414.698 143.476 412.517 143.476 412.517C143.476 412.517 144.794 420.823 139.797 422.703L139.81 422.703ZM149.831 340.051C149.831 343.695 149.427 381.58 149.427 386.033C149.427 390.486 148.578 411.616 148.265 413.588C147.952 415.56 146.582 411.329 146.582 411.329L146.308 407.228C146.308 407.228 147.117 400.254 147.26 394.391C147.391 388.514 147.743 367.933 147.743 362.069L147.743 340.992C147.743 338.902 147.965 338.419 148.631 337.701C149.296 336.996 149.831 336.408 149.831 340.051ZM143.633 328.598C144.86 328.598 146.138 329.173 146.19 332.072C146.23 334.984 145.003 395.109 145.003 397.577C145.003 400.046 144.651 408.508 142.015 409.696C139.379 410.885 136.587 411.42 132.215 411.551L39.3221 411.551C34.9509 411.42 32.1715 410.885 29.5226 409.696C26.8868 408.508 26.5345 400.045 26.5345 397.577C26.5345 395.109 25.2949 334.971 25.3471 332.072C25.3862 329.16 26.665 328.598 27.9046 328.598L143.633 328.598ZM133.507 325.947L133.507 326.979L38.3044 326.979L38.3044 325.947L133.52 325.947L133.507 325.947Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M26.5332 397.669C26.5332 400.241 26.9116 408.521 29.5213 409.696C32.1572 410.885 34.9496 411.42 39.3209 411.551L132.201 411.551C136.572 411.42 139.352 410.885 142.001 409.696C144.61 408.521 144.989 400.241 144.989 397.669L26.5332 397.669Z",
    fill: "url(#paint1_linear_3111_39277)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.056 414.944L51.407 414.944C51.407 414.944 39.3892 414.787 36.7795 414.604C31.9123 414.265 27.6454 412.084 27.6454 412.084C27.6454 412.084 26.3275 420.39 31.3251 422.27C36.3228 424.164 40.681 425.013 50.3761 425.013L121.113 425.013C130.808 425.013 135.166 424.164 140.164 422.27C145.161 420.39 143.844 412.084 143.844 412.084C143.844 412.084 139.577 414.265 134.709 414.604C132.1 414.787 120.082 414.944 120.082 414.944L120.056 414.944Z",
    fill: "#D0E1EE"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_3111_39277",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.66 403.807L151.762 402.253C151.762 402.253 154.085 403.376 156.003 402.488C157.934 401.6 161.418 399.406 162.384 397.8C163.349 396.18 162.893 393.999 162.893 393.999L146.973 400.033L146.66 403.82L146.66 403.807Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.66 403.807L151.762 402.253C151.762 402.253 154.085 403.376 156.003 402.488C157.934 401.6 161.418 399.406 162.384 397.8C163.349 396.18 162.893 393.999 162.893 393.999L146.973 400.033L146.66 403.82L146.66 403.807Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 2,
    mask: "url(#path-7-inside-2_3111_39277)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-3_3111_39277",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3336 403.807L20.2316 402.253C20.2316 402.253 17.9089 403.376 15.9908 402.488C14.0596 401.6 10.5756 399.406 9.61001 397.8C8.64441 396.18 9.08807 393.999 9.08807 393.999L25.0205 400.033L25.3336 403.82L25.3336 403.807Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3336 403.807L20.2316 402.253C20.2316 402.253 17.9089 403.376 15.9908 402.488C14.0596 401.6 10.5756 399.406 9.61001 397.8C8.64441 396.18 9.08807 393.999 9.08807 393.999L25.0205 400.033L25.3336 403.82L25.3336 403.807Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 2,
    mask: "url(#path-8-inside-3_3111_39277)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.594 413.418C143.776 415.625 143.803 421.202 139.823 422.703C134.825 424.597 130.467 425.446 120.772 425.446L50.035 425.446C40.3399 425.446 35.9816 424.597 30.984 422.703C26.704 421.084 27.0564 414.75 27.2521 412.987C27.0042 412.804 26.8476 412.582 26.7562 412.256C26.5083 411.329 25.5558 406.876 25.5558 406.876L22.7894 415.795C22.7894 415.795 21.8891 417.532 23.9508 420.34C26.0125 423.134 30.3316 427.418 37.9911 427.992C45.6376 428.58 51.653 428.58 51.653 428.58L52.0445 429.755C53.8844 429.821 55.8025 429.873 57.7076 429.873L57.7076 432.367L61.7788 434.013L110.137 434.013L114.208 432.367L114.208 429.873C116.061 429.873 117.914 429.834 119.702 429.755L120.093 428.567C120.093 428.567 126.109 428.567 133.755 427.979C141.402 427.392 145.734 423.121 147.795 420.327C149.857 417.532 148.957 415.782 148.957 415.782L146.19 406.863C146.19 406.863 145.251 411.329 144.99 412.243C144.82 412.857 144.442 413.118 143.581 413.418L143.594 413.418ZM112.499 429.416L112.499 431.349L109.641 432.55L61.9745 432.55L59.3517 431.414L59.3517 429.429L112.499 429.429L112.499 429.416Z",
    fill: "#21292B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.809 419.386C134.811 421.28 130.453 422.116 120.758 422.116L50.034 422.116C40.3389 422.116 35.9807 421.267 30.983 419.386C28.3472 418.394 27.4729 415.599 27.225 413.196C27.0423 415.207 26.8466 421.149 30.983 422.703C35.9807 424.597 40.3389 425.446 50.034 425.446L120.771 425.446C130.466 425.446 134.824 424.597 139.822 422.703C143.945 421.149 143.762 415.207 143.58 413.196C143.345 415.599 142.471 418.394 139.822 419.386L139.809 419.386Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9492 321.573L65.0275 322.761L108.179 322.761L108.062 321.573L102.673 315.761L70.7559 315.761L64.9492 321.573Z",
    fill: "#0B1417"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9863 159.012L83.9863 219.45L89.0361 219.45L89.0362 159.012L83.9863 159.012Z",
    fill: "url(#paint2_linear_3111_39277)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4043 161.767L81.4043 168.858L91.4648 168.858L91.4648 161.767L81.4043 161.767Z",
    fill: "url(#paint3_linear_3111_39277)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 285.895L81.6777 295.585L91.399 295.585L91.399 285.895L81.6777 285.895Z",
    fill: "url(#paint4_linear_3111_39277)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3125 231.556L84.3125 285.895L89.2057 285.895L89.2057 231.556L84.3125 231.556Z",
    fill: "url(#paint5_linear_3111_39277)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9512 233.044L81.9512 239.587L91.3984 239.587L91.3984 233.044L81.9512 233.044Z",
    fill: "url(#paint6_linear_3111_39277)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.916 221.931L79.916 225.835L93.3822 225.835L93.3822 221.931L79.916 221.931Z",
    fill: "url(#paint7_linear_3111_39277)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4043 219.162L81.4043 221.931L92.6131 221.931L92.6131 219.162L81.4043 219.162Z",
    fill: "url(#paint8_linear_3111_39277)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.886 225.836L89.9762 231.556L83.1126 231.556L80.6855 225.836L92.886 225.836Z",
    fill: "url(#paint9_linear_3111_39277)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6973 297.165L74.6973 299.529L97.9891 299.529L97.9891 297.165L74.6973 297.165Z",
    fill: "url(#paint10_linear_3111_39277)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8496 295.258L76.8496 297.165L96.1355 297.165L96.1355 295.258L76.8496 295.258Z",
    fill: "url(#paint11_linear_3111_39277)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.041 299.529L79.041 304.622L94.3732 304.622L94.3732 299.529L79.041 299.529Z",
    fill: "url(#paint12_linear_3111_39277)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-4_3111_39277",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2793 310.094L77.2793 317.956L96.1215 317.956L96.1215 310.094L77.2793 310.094Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2793 310.094L77.2793 317.956L96.1215 317.956L96.1215 310.094L77.2793 310.094Z",
    fill: "url(#paint13_linear_3111_39277)",
    stroke: "#222222",
    strokeWidth: 2,
    mask: "url(#path-23-inside-4_3111_39277)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1346 310.094L94.373 304.622L79.0409 304.622L77.2793 310.094L96.1346 310.094Z",
    fill: "url(#paint14_linear_3111_39277)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4668 141.147L75.4668 149.779L96.9318 149.779L96.9318 141.147L75.4668 141.147Z",
    fill: "url(#paint15_linear_3111_39277)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9449 141.146C96.9449 141.146 95.3008 142.191 95.3008 145.273C95.3008 148.629 96.9449 149.4 96.9449 149.4L104.33 149.4L104.33 141.146L96.9449 141.146Z",
    fill: "url(#paint16_linear_3111_39277)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0672 141.146C76.0672 141.146 77.7113 142.191 77.7113 145.273C77.7113 148.629 76.0672 149.4 76.0672 149.4L68.6816 149.4L68.6816 141.146L76.0672 141.146Z",
    fill: "url(#paint17_linear_3111_39277)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4662 141.146L96.9312 141.146C96.9312 141.146 92.2206 136.941 86.1922 136.941C80.1637 136.941 75.4531 141.146 75.4531 141.146L75.4662 141.146Z",
    fill: "url(#paint18_radial_3111_39277)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9876 159.024L89.0374 159.024C89.0374 159.024 95.0528 157.601 96.9318 149.778L75.4668 149.778C75.4668 149.778 76.1584 157.261 83.9876 159.024Z",
    fill: "url(#paint19_radial_3111_39277)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9863 95.8047L83.9863 140.676L89.0361 140.676L89.0362 95.8047L83.9863 95.8047Z",
    fill: "url(#paint20_linear_3111_39277)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4043 98.5602L81.4043 105.651L91.4648 105.651L91.4648 98.5602L81.4043 98.5602Z",
    fill: "url(#paint21_linear_3111_39277)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4668 77.9264L75.4668 86.5586L96.9318 86.5586L96.9318 77.9264L75.4668 77.9264Z",
    fill: "url(#paint22_linear_3111_39277)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9449 77.9267C96.9449 77.9267 95.3008 78.9715 95.3008 82.0535C95.3008 85.4097 96.9449 86.1802 96.9449 86.1802L104.33 86.1802L104.33 77.9267L96.9449 77.9267Z",
    fill: "url(#paint23_linear_3111_39277)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0672 77.9267C76.0672 77.9267 77.7113 78.9715 77.7113 82.0535C77.7113 85.4097 76.0672 86.1802 76.0672 86.1802L68.6816 86.1802L68.6816 77.9267L76.0672 77.9267Z",
    fill: "url(#paint24_linear_3111_39277)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9876 95.8047L89.0374 95.8047C89.0374 95.8047 95.0528 94.3682 96.9318 86.5588L75.4668 86.5588C75.4668 86.5588 76.1584 94.0417 83.9876 95.8047Z",
    fill: "url(#paint25_radial_3111_39277)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2168 8.75171L61.2168 24.9321L67.8455 24.9321L67.8455 8.75171L61.2168 8.75171Z",
    fill: "#172023"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3672 18.285L65.3672 21.6021L106.405 21.6021L106.405 18.285L65.3672 18.285Z",
    fill: "#172023"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M46.916 193.788L46.916 243.674L62.1438 243.674L62.1438 193.788L46.916 193.788Z",
    fill: "#172023"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1406 251.876L53.1406 315.762L62.6792 315.762L62.6792 251.876L53.1406 251.876Z",
    fill: "#172023"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M47.75 124.078L47.75 165.149L55.6314 165.149L55.6314 124.078L47.75 124.078Z",
    fill: "#172023"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.75 61.0278L47.75 102.099L55.6314 102.099L55.6314 61.0278L47.75 61.0278Z",
    fill: "#172023"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4102 29.6727L63.4102 321.729L70.7304 321.729L70.7305 29.6727L63.4102 29.6727Z",
    fill: "#172023"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 113.526L18.875 177.843L50.6223 177.843L50.6223 113.526L18.875 113.526Z",
    fill: "url(#paint26_linear_3111_39277)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8748 113.526L18.8748 177.843L17.7656 176.667L17.7656 114.701L18.8748 113.526Z",
    fill: "url(#paint27_linear_3111_39277)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7322 114.701L51.7322 176.667L50.623 177.843L50.623 113.526L51.7322 114.701Z",
    fill: "url(#paint28_linear_3111_39277)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 48.0993L18.875 112.416L50.6223 112.416L50.6223 48.0993L18.875 48.0993Z",
    fill: "url(#paint29_linear_3111_39277)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8748 48.0993L18.8748 112.416L17.7656 111.241L17.7656 49.2746L18.8748 48.0993Z",
    fill: "url(#paint30_linear_3111_39277)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7322 49.2746L51.7322 111.241L50.623 112.416L50.623 48.0993L51.7322 49.2746Z",
    fill: "url(#paint31_linear_3111_39277)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1563 34.0607L48.1562 40.6948L61.8312 40.6948L61.8312 34.0608L48.1563 34.0607Z",
    fill: "#172023"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9629 34.4654L53.9629 208.715L62.2488 208.715L62.2488 34.4654L53.9629 34.4654Z",
    fill: "#172023"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M111.076 193.788L111.076 243.674L126.304 243.674L126.304 193.788L111.076 193.788Z",
    fill: "#172023"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M110.555 251.876L110.555 315.762L120.093 315.762L120.093 251.876L110.555 251.876Z",
    fill: "#172023"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M117.6 124.078L117.6 165.149L125.481 165.149L125.481 124.078L117.6 124.078Z",
    fill: "#172023"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M117.6 61.0278L117.6 102.099L125.481 102.099L125.481 61.0278L117.6 61.0278Z",
    fill: "#172023"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M105.164 8.75171L105.164 24.9321L111.793 24.9321L111.793 8.75171L105.164 8.75171Z",
    fill: "#172023"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5977 24.3707L20.5977 31.4097L151.671 31.4097L151.671 24.3707L20.5977 24.3707Z",
    fill: "#172023"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2461 17.6452L59.2461 322.761L65.0397 322.761L65.0397 17.6452L59.2461 17.6452Z",
    fill: "url(#paint32_linear_3111_39277)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M102.477 29.6727L102.477 321.729L109.797 321.729L109.797 29.6727L102.477 29.6727Z",
    fill: "#172023"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 113.526L122.6 177.843L154.347 177.843L154.347 113.526L122.6 113.526Z",
    fill: "url(#paint33_linear_3111_39277)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M154.346 113.526L154.346 177.843L155.455 176.667L155.455 114.701L154.346 113.526Z",
    fill: "url(#paint34_linear_3111_39277)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M121.477 114.701L121.477 176.667L122.599 177.843L122.599 113.526L121.477 114.701Z",
    fill: "url(#paint35_linear_3111_39277)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 48.0993L122.6 112.416L154.347 112.416L154.347 48.0993L122.6 48.0993Z",
    fill: "url(#paint36_linear_3111_39277)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M154.346 48.0993L154.346 112.416L155.455 111.241L155.455 49.2746L154.346 48.0993Z",
    fill: "url(#paint37_linear_3111_39277)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M121.477 49.2746L121.477 111.241L122.599 112.416L122.599 48.0993L121.477 49.2746Z",
    fill: "url(#paint38_linear_3111_39277)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4473 6.04836L16.4473 11.0239L154.345 11.0239L154.345 6.04837L16.4473 6.04836Z",
    fill: "#565F62"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8535 32.9635L66.8535 72.7681L104.421 72.7681L104.421 32.9635L66.8535 32.9635Z",
    fill: "url(#paint39_linear_3111_39277)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M111.377 34.0607L111.377 40.6948L125.052 40.6948L125.052 34.0608L111.377 34.0607Z",
    fill: "#172023"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M110.959 34.4654L110.959 208.715L119.245 208.715L119.245 34.4654L110.959 34.4654Z",
    fill: "#172023"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M108.18 17.6452L108.18 322.761L113.973 322.761L113.973 17.6452L108.18 17.6452Z",
    fill: "url(#paint40_linear_3111_39277)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6816 296.682L68.6816 305.393L105.166 305.393L105.166 296.682L68.6816 296.682Z",
    fill: "#242D30"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6816 231.542L68.6816 240.253L105.166 240.253L105.166 231.542L68.6816 231.542Z",
    fill: "#242D30"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6816 88.8183L68.6816 97.5288L105.166 97.5288L105.166 88.8183L68.6816 88.8183Z",
    fill: "#242D30"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6816 119.938L68.6816 128.649L105.166 128.649L105.166 119.938L68.6816 119.938Z",
    fill: "#242D30"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6816 153.122L68.6816 189.217L105.166 189.217L105.166 153.122L68.6816 153.122Z",
    fill: "#242D30"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6816 285.477L68.6816 292.111L105.166 292.111L105.166 285.477L68.6816 285.477Z",
    fill: "#242D30"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2344 226.436L18.2344 282.147L53.9093 282.147L53.9093 226.436L18.2344 226.436Z",
    fill: "url(#paint41_linear_3111_39277)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 264.791L17.2695 269.101L54.7844 269.101L54.7844 264.791L17.2695 264.791Z",
    fill: "url(#paint42_linear_3111_39277)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2344 269.101L18.2344 269.714L53.9093 269.714L53.9093 269.101L18.2344 269.101Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2344 264.177L18.2344 264.791L53.9093 264.791L53.9093 264.177L18.2344 264.177Z",
    fill: "black"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 237.119L17.2695 241.428L54.7844 241.428L54.7844 237.119L17.2695 237.119Z",
    fill: "url(#paint43_linear_3111_39277)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2344 241.428L18.2344 242.042L53.9093 242.042L53.9093 241.428L18.2344 241.428Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2344 236.505L18.2344 237.119L53.9093 237.119L53.9093 236.505L18.2344 236.505Z",
    fill: "black"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4974 210.374C42.6089 210.374 39.4512 213.534 39.4512 217.426C39.4512 221.317 42.6089 224.478 46.4974 224.478C50.3859 224.478 53.5437 221.317 53.5437 217.426C53.5437 213.534 50.3859 210.374 46.4974 210.374Z",
    fill: "#172023"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4974 195.852C42.6089 195.852 39.4512 199.012 39.4512 202.904C39.4512 206.795 42.6089 209.956 46.4974 209.956C50.3859 209.956 53.5437 206.795 53.5437 202.904C53.5437 199.012 50.3859 195.852 46.4974 195.852Z",
    fill: "#172023"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M118.422 21.38L118.422 24.5142L148.094 24.5142L148.094 21.38L118.422 21.38Z",
    fill: "#A30413"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M118.422 21.38L118.422 24.5142L148.094 24.5142L148.094 21.38L118.422 21.38Z",
    fill: "url(#paint44_linear_3111_39277)"
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M141.23 21.38L141.23 24.5142L148.107 24.5142L148.107 21.38L141.23 21.38Z",
    fill: "#DD8E21"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M127.465 21.38L127.465 24.5142L131.836 24.5142L131.836 21.38L127.465 21.38Z",
    fill: "#E3E3E4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M118.422 22.3594L118.422 24.5142L148.094 24.5142L148.094 22.3594L118.422 22.3594Z",
    fill: "#565F62"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0801 21.38L24.0801 24.5142L53.7527 24.5142L53.7527 21.38L24.0801 21.38Z",
    fill: "#A30413"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M24.0801 21.38L24.0801 24.5142L53.7527 24.5142L53.7527 21.38L24.0801 21.38Z",
    fill: "url(#paint45_linear_3111_39277)"
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0801 21.38L24.0801 24.5142L30.9567 24.5142L30.9567 21.38L24.0801 21.38Z",
    fill: "#DD8E21"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3379 21.38L40.3379 24.5142L44.7092 24.5142L44.7092 21.38L40.3379 21.38Z",
    fill: "#E3E3E4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0801 22.3594L24.0801 24.5142L53.7527 24.5142L53.7527 22.3594L24.0801 22.3594Z",
    fill: "#565F62"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M119.322 226.436L119.322 282.147L154.997 282.147L154.997 226.436L119.322 226.436Z",
    fill: "url(#paint46_linear_3111_39277)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M118.422 264.791L118.422 269.101L155.937 269.101L155.937 264.791L118.422 264.791Z",
    fill: "url(#paint47_linear_3111_39277)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M119.322 269.101L119.322 269.714L154.997 269.714L154.997 269.101L119.322 269.101Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M119.322 264.177L119.322 264.791L154.997 264.791L154.997 264.177L119.322 264.177Z",
    fill: "black"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M118.422 237.119L118.422 241.428L155.937 241.428L155.937 237.119L118.422 237.119Z",
    fill: "url(#paint48_linear_3111_39277)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M119.322 241.428L119.322 242.042L154.997 242.042L154.997 241.428L119.322 241.428Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M119.322 236.505L119.322 237.119L154.997 237.119L154.997 236.505L119.322 236.505Z",
    fill: "black"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M126.722 210.374C130.611 210.374 133.768 213.534 133.768 217.426C133.768 221.317 130.611 224.478 126.722 224.478C122.834 224.478 119.676 221.317 119.676 217.426C119.676 213.534 122.834 210.374 126.722 210.374Z",
    fill: "#172023"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M126.722 195.852C130.611 195.852 133.768 199.012 133.768 202.904C133.768 206.795 130.611 209.956 126.722 209.956C122.834 209.956 119.676 206.795 119.676 202.904C119.676 199.012 122.834 195.852 126.722 195.852Z",
    fill: "#172023"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7735 0L13.7734 307.561L158.235 307.561L158.235 6.31461e-06L13.7735 0Z",
    fill: "#222222"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-105-inside-5_3111_39277",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9883 6.0127L22.9883 300.013L150.988 300.013L150.988 6.0127L22.9883 6.0127Z"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9883 6.0127L22.9883 300.013L150.988 300.013L150.988 6.0127L22.9883 6.0127Z",
    fill: "#222222",
    stroke: "url(#paint49_linear_3111_39277)",
    strokeWidth: 8,
    mask: "url(#path-105-inside-5_3111_39277)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.07
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7735 0L13.7734 307.561L17.4401 307.561L17.4401 1.60275e-07L13.7735 0Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.07
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M154.555 0L154.555 307.561L158.221 307.561L158.221 1.60275e-07L154.555 0Z",
    fill: "black"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.9863,
    y: 398.013,
    width: 39,
    height: 13,
    transform: "rotate(-90 51.9863 398.013)",
    fill: "#222222"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79.9863,
    y: 398.013,
    width: 39,
    height: 13,
    transform: "rotate(-90 79.9863 398.013)",
    fill: "#222222"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 107.986,
    y: 398.013,
    width: 39,
    height: 13,
    transform: "rotate(-90 107.986 398.013)",
    fill: "#222222"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6387 245.314L100.289 245.314L100.289 253.384L84.9397 253.384L84.9397 267.942L100.289 267.942L100.289 276.013L64.6387 276.013L64.6387 267.942L78.1067 267.942L78.1067 253.384L64.6387 253.384L64.6387 245.314Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0211 210.506C95.2405 210.506 100.935 216.695 100.935 225.311C100.935 233.976 95.2405 240.116 87.0211 240.116C78.8511 240.116 73.1074 233.976 73.1074 225.311C73.1074 216.695 78.8511 210.506 87.0211 210.506ZM87.0211 218.478C81.3764 218.478 79.3463 220.904 79.3463 225.311C79.3463 229.767 81.3764 232.144 87.0211 232.144C92.7152 232.144 94.6958 229.767 94.6958 225.311C94.6958 220.904 92.7153 218.478 87.0211 218.478Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0528 193.719L100.292 193.719L100.292 194.957C100.292 201.889 96.6771 205.9 90.4878 205.9L60.3828 205.9L60.3828 198.225L90.2402 198.225C93.2111 198.225 94.0528 197.185 94.0528 194.561L94.0528 193.719Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7511 129.894L97.023 129.894C105.985 129.894 110.986 134.202 110.986 144.798C110.986 152.72 107.273 156.285 101.974 158.167L101.974 150.789C104.153 149.997 104.896 148.016 104.896 144.699C104.896 139.599 103.658 137.569 97.9143 137.569L95.7357 137.569C97.9638 138.955 99.3997 140.985 99.3997 145.541C99.3997 152.324 93.9531 158.662 86.4269 158.662C78.7026 158.662 73.1074 152.77 73.1074 145.541C73.1074 141.183 75.1375 138.807 77.2171 137.569L73.7511 137.569L73.7511 129.894ZM84.3473 137.569C80.8812 138.708 79.2968 139.995 79.2968 144.6C79.2968 148.363 81.4259 150.69 86.4269 150.69C92.022 150.69 93.7055 148.413 93.7055 144.55C93.7055 139.599 92.022 138.361 88.5065 137.569L84.3473 137.569Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6521 105.732L80.7822 105.732C80.4356 106.524 80.2375 107.712 80.2375 109.198C80.2375 113.555 82.3172 116.477 87.9123 116.477L100.291 116.477L100.291 124.151L73.7511 124.151L73.7511 116.477L77.6133 116.477C74.8404 115.14 73.1074 112.317 73.1074 108.752C73.1074 107.613 73.3055 106.475 73.6521 105.732Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0521 75.527L100.291 75.527L100.291 76.6659C100.291 81.0231 99.1522 82.6076 97.0725 83.7465C99.3502 84.9348 100.935 88.5989 100.935 92.9067C100.935 98.3533 98.2114 103.651 92.2696 103.651C86.4269 103.651 83.9016 97.561 83.9016 91.8668C83.8649 89.8078 84.3234 87.77 85.2385 85.9251L83.2579 85.9251C80.188 85.9251 78.9502 86.9154 78.9502 90.629C78.9502 93.2037 79.3463 94.5406 81.2773 95.1843L81.2773 102.661C75.3851 100.78 73.1074 96.3727 73.1074 90.6785C73.1074 82.6571 76.9201 78.2503 83.555 78.2503L91.824 78.2503C93.557 78.2503 94.0521 77.4581 94.0521 76.1707L94.0521 75.527ZM90.19 85.9251C89.2492 87.262 88.7046 88.4998 88.7046 91.6193C88.7046 94.7882 89.6453 95.7785 91.9725 95.7785C94.1512 95.7785 95.0919 94.7882 95.0919 91.9164C95.0919 88.9455 94.6958 87.361 92.7648 85.9251L90.19 85.9251Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6303 53.4434L66.8196 53.4434C66.4225 54.8109 66.2225 56.2281 66.2254 57.6521C66.2254 59.9793 67.3148 61.3657 70.1371 61.3657L73.7517 61.3657L73.7517 53.9385L79.9905 53.9385L79.9905 61.3657L100.292 61.3657L100.292 69.0405L79.9905 69.0405L79.9905 74.2891L73.7517 74.2891L73.7517 69.0405L70.0876 69.0405C64.2449 69.0405 59.9866 64.4852 59.9866 58.89C59.9777 57.055 60.1939 55.2258 60.6303 53.4434Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1703 162.279C94.1087 162.279 99.6082 168.357 99.6082 176.816C99.6082 185.325 94.1087 191.355 86.1703 191.355C78.2797 191.355 72.7324 185.325 72.7324 176.816C72.7348 168.355 78.2797 162.279 86.1703 162.279Z",
    fill: "#222222",
    stroke: "url(#paint50_radial_3111_39277)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7278 174.365C94.7277 170.379 93.5232 166.489 91.2774 163.222C96.3704 165.24 99.6104 170.327 99.6104 176.816C99.6104 179.959 98.8572 182.765 97.511 185.053C96.6454 184.367 95.9448 183.49 95.4625 182.488C94.9803 181.486 94.729 180.385 94.7278 179.269L94.7278 174.365ZM89.9049 174.365L89.9049 179.269C89.905 181.075 90.2992 182.859 91.0592 184.491C91.8192 186.124 92.926 187.565 94.2998 188.71C94.9486 188.21 95.5476 187.646 96.0883 187.027C94.9176 186.114 93.9689 184.94 93.3155 183.594C92.6621 182.249 92.3215 180.769 92.3199 179.269L92.3199 174.365C92.3204 169.86 90.5717 165.536 87.4541 162.335C87.0333 162.298 86.6076 162.279 86.1749 162.279C85.4168 162.278 84.6598 162.337 83.9105 162.454C85.7663 163.814 87.2776 165.604 88.3198 167.675C89.3621 169.746 89.9054 172.039 89.9049 174.365ZM77.8491 174.365C77.8485 173.715 77.5943 173.092 77.1425 172.633C76.6906 172.173 76.0779 171.915 75.4389 171.914L73.4184 171.914C72.9573 173.506 72.727 175.158 72.7346 176.818C72.7346 183.035 75.6971 187.924 80.3669 190.11C78.715 186.744 77.8539 183.034 77.8515 179.271L77.8491 174.365ZM82.6719 174.365C82.669 172.502 81.9719 170.71 80.7211 169.349C79.4703 167.989 77.7588 167.161 75.9314 167.032C75.3306 167.784 74.8103 168.599 74.3796 169.463L75.4389 169.463C76.7174 169.465 77.943 169.983 78.847 170.902C79.7511 171.821 80.2598 173.067 80.2617 174.367L80.2617 179.269C80.2599 183.481 81.4538 187.604 83.7001 191.143C84.5168 191.285 85.3439 191.356 86.1725 191.355C86.3805 191.355 86.5837 191.355 86.7894 191.34C84.1217 187.902 82.672 183.649 82.6743 179.269L82.6719 174.365ZM87.4947 179.269L87.4947 174.365C87.493 172.071 86.858 169.825 85.6622 167.88C84.4663 165.935 82.7575 164.371 80.7303 163.366C79.7791 163.776 78.8819 164.305 78.0595 164.941C80.0782 165.523 81.8558 166.757 83.1229 168.457C84.3901 170.158 85.0778 172.232 85.0821 174.365L85.0821 179.269C85.0847 183.604 86.7089 187.777 89.6252 190.939C90.4942 190.729 91.3395 190.429 92.1478 190.042C90.6822 188.671 89.512 187.005 88.7111 185.151C87.9103 183.297 87.4961 181.294 87.4947 179.269Z",
    fill: "url(#paint51_radial_3111_39277)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1703 162.279C94.1087 162.279 99.6082 168.357 99.6082 176.816C99.6082 185.325 94.1087 191.355 86.1703 191.355C78.2797 191.355 72.7324 185.325 72.7324 176.816C72.7348 168.355 78.2797 162.279 86.1703 162.279Z",
    stroke: "url(#paint52_radial_3111_39277)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0588 39.3099C85.0544 34.2198 86.5975 28.1909 92.5212 28.1909C98.8432 28.1909 101.083 34.4175 101.083 40.6936C101.083 48.0568 98.196 52.0597 92.2723 53.4434L92.2723 46.1789C94.1639 45.6848 95.2093 44.8447 95.2093 40.9407C95.2093 37.5802 94.6617 36.0483 93.019 36.0483C91.1274 36.0483 90.779 36.7896 89.9327 41.0395C88.9869 45.8824 87.3442 52.5044 81.2712 52.5044C75.6462 52.5044 73.1074 46.9696 73.1074 40.5453C73.1074 33.9233 75.9946 29.6734 81.3707 28.4379L81.3707 35.7024C79.6783 36.3942 78.9813 37.1849 78.9813 40.2982C78.9813 43.6092 79.6783 44.7458 81.2214 44.7458C82.665 44.7458 83.2126 43.6586 84.0588 39.3099Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3111_39277",
    x1: 167.603,
    y1: 426.188,
    x2: 122.559,
    y2: 290.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3111_39277",
    x1: 85.761,
    y1: 400.633,
    x2: 85.761,
    y2: 425.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3111_39277",
    x1: 89.0492,
    y1: 189.231,
    x2: 83.9863,
    y2: 189.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#314045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3111_39277",
    x1: 91.4648,
    y1: 165.319,
    x2: 81.4043,
    y2: 165.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3111_39277",
    x1: 91.412,
    y1: 290.74,
    x2: 81.6908,
    y2: 290.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3111_39277",
    x1: 89.2057,
    y1: 258.732,
    x2: 84.3255,
    y2: 258.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#314045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3111_39277",
    x1: 91.4114,
    y1: 236.322,
    x2: 81.9512,
    y2: 236.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3111_39277",
    x1: 93.3822,
    y1: 223.89,
    x2: 79.9291,
    y2: 223.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3111_39277",
    x1: 92.6131,
    y1: 220.559,
    x2: 81.4043,
    y2: 220.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#253439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3111_39277",
    x1: 92.886,
    y1: 228.696,
    x2: 80.6855,
    y2: 228.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#314045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3111_39277",
    x1: 98.0021,
    y1: 298.353,
    x2: 74.7103,
    y2: 298.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3111_39277",
    x1: 96.1355,
    y1: 296.212,
    x2: 76.8496,
    y2: 296.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#253439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3111_39277",
    x1: 94.3732,
    y1: 302.076,
    x2: 79.041,
    y2: 302.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3111_39277",
    x1: 98.1473,
    y1: 317.436,
    x2: 96.6084,
    y2: 307.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3111_39277",
    x1: 96.1346,
    y1: 307.364,
    x2: 77.2923,
    y2: 307.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#243338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3111_39277",
    x1: 96.9449,
    y1: 145.469,
    x2: 75.4798,
    y2: 145.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3111_39277",
    x1: 99.8156,
    y1: 149.4,
    x2: 99.8156,
    y2: 141.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3111_39277",
    x1: 73.1965,
    y1: 149.4,
    x2: 73.1965,
    y2: 141.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3111_39277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.2052 139.044) rotate(-90) scale(7.74413 7.73784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_3111_39277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.4193 153.827) rotate(-90) scale(10.4996 10.4911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3111_39277",
    x1: -320.808,
    y1: 118.24,
    x2: -320.808,
    y2: 118.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#314045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3111_39277",
    x1: -320.807,
    y1: 102.099,
    x2: -320.807,
    y2: 102.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3111_39277",
    x1: 96.9449,
    y1: 82.249,
    x2: 75.4798,
    y2: 82.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3111_39277",
    x1: 99.8156,
    y1: 86.1802,
    x2: 99.8156,
    y2: 77.9267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3111_39277",
    x1: 73.1965,
    y1: 86.1802,
    x2: 73.1965,
    y2: 77.9267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00090C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3111_39277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.4193 90.6202) rotate(-90) scale(10.4996 10.4911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3111_39277",
    x1: 34.7421,
    y1: 177.843,
    x2: 34.7421,
    y2: 113.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#485154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151E21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3111_39277",
    x1: 190.698,
    y1: 177.843,
    x2: 190.698,
    y2: 113.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3111_39277",
    x1: 228.256,
    y1: 3124.86,
    x2: 228.256,
    y2: 3123.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3111_39277",
    x1: -526.571,
    y1: 112.416,
    x2: -526.571,
    y2: 48.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#485154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151E21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3111_39277",
    x1: -1188.35,
    y1: 112.416,
    x2: -1188.35,
    y2: 48.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3111_39277",
    x1: 228.256,
    y1: 112.416,
    x2: 228.256,
    y2: 48.0993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3111_39277",
    x1: 65.6626,
    y1: 302.587,
    x2: 46.1434,
    y2: 301.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3111_39277",
    x1: 138.467,
    y1: 3124.86,
    x2: 138.467,
    y2: 3123.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#485154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151E21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3111_39277",
    x1: 236.201,
    y1: 177.843,
    x2: 236.201,
    y2: 113.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3111_39277",
    x1: 198.645,
    y1: 177.843,
    x2: 198.645,
    y2: 113.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3111_39277",
    x1: 138.467,
    y1: 112.416,
    x2: 138.467,
    y2: 48.0993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#485154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151E21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3111_39277",
    x1: 236.201,
    y1: 112.416,
    x2: 236.201,
    y2: 48.0993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3111_39277",
    x1: 198.645,
    y1: 112.416,
    x2: 198.645,
    y2: 48.0993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3111_39277",
    x1: 85.6305,
    y1: 72.755,
    x2: 85.6305,
    y2: 32.9635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3111_39277",
    x1: 114.596,
    y1: 302.587,
    x2: 95.077,
    y2: 301.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3111_39277",
    x1: 54.0268,
    y1: 254.292,
    x2: 18.391,
    y2: 254.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3111_39277",
    x1: 54.9279,
    y1: 266.946,
    x2: 17.4522,
    y2: 266.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3111_39277",
    x1: 54.9279,
    y1: 239.273,
    x2: 17.4522,
    y2: 239.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3111_39277",
    x1: 147.912,
    y1: 22.9471,
    x2: 124.998,
    y2: 22.9471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3111_39277",
    x1: 24.2628,
    y1: 22.9471,
    x2: 47.1631,
    y2: 22.9471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3111_39277",
    x1: 119.192,
    y1: 254.292,
    x2: 154.815,
    y2: 254.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3111_39277",
    x1: 118.291,
    y1: 266.946,
    x2: 155.767,
    y2: 266.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3111_39277",
    x1: 118.291,
    y1: 239.273,
    x2: 155.767,
    y2: 239.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3111_39277",
    x1: 164.75,
    y1: 280.573,
    x2: -20.6684,
    y2: 66.6028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_3111_39277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.04 166.721) rotate(-120.14) scale(61.1725 31.4616)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_3111_39277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.042 166.721) rotate(-120.14) scale(61.1726 31.4618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_3111_39277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.04 166.721) rotate(-120.14) scale(61.1725 31.4616)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckDown);
export default __webpack_public_path__ + "static/media/truck-down.e78d7ea3fa7ecc4179cac2b2c4b42bd8.svg";
export { ForwardRef as ReactComponent };